import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { CddDomesticWireVolumesForm } from './CddDomesticWireVolumesForm';
import { useCddDomesticWireLogic } from './hooks/useCddDomesticWireLogic';

export const CddDomesticWireVolumes = () => {
  const { t } = useTranslation('cddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useCddDomesticWireLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('domesticWireVolumes.subtitle')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'>
        <CddDomesticWireVolumesForm
          contentKeys={{
            domesticWiresIncoming: 'domesticWireVolumes.domesticWiresIncoming',
            domesticWiresOutgoing: 'domesticWireVolumes.domesticWiresOutgoing',
          }}
        />
      </StepPageWrapper>
    </FormProvider>
  );
};
